export default function getMarginBottomLg(value) {
  switch (value) {
    case -44:
      return "lg:-mb-44";
    case -40:
      return "lg:-mb-40";
    case -36:
      return "lg:-mb-36";
    case -32:
      return "lg:-mb-32";
    case -28:
      return "lg:-mb-28";
    case -24:
      return "lg:-mb-24";
    case -20:
      return "lg:-mb-20";
    case -16:
      return "lg:-mb-16";
    case -12:
      return "lg:-mb-12";
    case -8:
      return "lg:-mb-8";
    case -4:
      return "lg:-mb-4";
    case 0:
      return "lg:mb-0";
    case 1:
      return "lg:mb-1";
    case 2:
      return "lg:mb-2";
    case 3:
      return "lg:mb-3";
    case 4:
      return "lg:mb-4";
    case 5:
      return "lg:mb-5";
    case 6:
      return "lg:mb-6";
    case 7:
      return "lg:mb-7";
    case 8:
      return "lg:mb-8";
    case 9:
      return "lg:mb-9";
    case 10:
      return "lg:mb-10";
    case 12:
      return "lg:mb-12";
    case 14:
      return "lg:mb-14";
    case 16:
      return "lg:mb-16";
    case 20:
      return "lg:mb-20";
    case 24:
      return "lg:mb-24";
    default:
      return "";
  }
}
